export default "__VITE_ASSET__dB4mtUrZ__"